export default {}

export const NOT_VERIFIED = 'NOT_VERIFIED'
export const ACTIVE = 'ACTIVE'
export const INVITED = 'INVITED'
export const DEACTIVATED = 'DEACTIVATED'
